import React from "react"
import { EmailLink } from "../link"

export const EmailCell = ({ value, last, empty = "-", style, className, handlers }) => {
  const align = last ? "right" : "left"
  return (
    <td scope="row" align={align} style={style} className={className} {...handlers}>
      {value ? <EmailLink value={value} /> : empty}
    </td>
  )
}
